import type { ReactNode } from "react";
import { ShieldOff } from "lucide-react";
import { useModuleContext } from "@/context/ModuleContext";
import { useModuleEnabled } from "@/hooks/admin/useModules";

// ---------------------------------------------------------------------------
// Props
// ---------------------------------------------------------------------------

interface ModuleGuardProps {
  readonly moduleKey: string;
  readonly region?: string;
  readonly children: ReactNode;
}

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export function ModuleGuard({
  moduleKey,
  region,
  children,
}: ModuleGuardProps) {
  const { isLoading } = useModuleContext();
  const isEnabled = useModuleEnabled(moduleKey, region);

  if (isLoading) {
    return null;
  }

  if (!isEnabled) {
    return (
      <div className="flex min-h-[40vh] flex-col items-center justify-center gap-3 text-center">
        <ShieldOff className="h-10 w-10 text-stone-300" />
        <h2 className="text-base font-semibold text-stone-700">
          Module désactivé
        </h2>
        <p className="max-w-xs text-sm text-muted-foreground">
          Ce module n&apos;est pas actif pour votre région. Contactez
          votre administrateur pour l&apos;activer.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
